import { QuestionScore } from '~teacher/models/activities';
import { QuizQuestion } from '~teacher/models/quizzes';

import { assignedGradingWeight } from './assignedGradingWeight';

/**
 * effective question weight calculates how many points are possible in a question.
 * It takes into account situations where a question has an assigned grading weight,
 * but since it does not have a questionScore override or a correct answer, it has no
 * grading weight.
 *
 * **Use this method for calculating the total number of possible points in a question/quiz**
 */
export function effectiveQuestionWeight({
  question,
  questionScore = null,
}: {
  question: QuizQuestion;
  questionScore?: QuestionScore;
}) {
  if (!questionScore && !question.hasCorrectAnswer) {
    return 0;
  }

  return assignedGradingWeight({ question, questionScore });
}
